import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onEditPrivateDistributionList = action("onEditPrivateDistributionList", event => ({
    event,
    owaType: "editPrivateDistributionList",
})) as OwaNovaActionUnion<"editPrivateDistributionList">;
